import type { FireworksEvent } from '@shared/types'

import { type EffectPlugin } from '@shared/lib/effect-registry'

import { FireworksEffect } from '../FireworksEffect'

/**
 * Плагин салюта.
 * sound.src — URL к аудиофайлу (mp3/ogg).
 * Замените на реальный URL или base64 строку.
 *
 * Рекомендация: разместить звуки в /public/sounds/ и
 * ссылаться как '/sounds/fireworks.mp3'
 */
export const fireworksPlugin: EffectPlugin<FireworksEvent> = {
  type: 'fireworks',
  component: FireworksEffect,
  sound: {
    src: '/sounds/fireworks.mp3',
    volume: 0.8,
    delayMs: 200,
  },
}
